import React from 'react'
import PrivateLayout from '../../layouts/PrivateLayout/PrivateLayout'
import storeImage from '../../assets/storeImage.png'
import { Button } from 'flowbite-react'
import storeIcon from '../../assets/shopping-cart.png'
import CustomButton from '../../components/CustomButton/CustomButton'
import { FaArrowRight } from 'react-icons/fa'
import { useNavigate } from 'react-router-dom'

const OnlineStore = () => {
    const navigate = useNavigate()
    return (
        <PrivateLayout>
            <div className='flex flex-col justify-center items-center my-8 w-full'>
                <div>
                    <img src={storeImage} />
                </div>
                <div className='flex flex-col w-1/2 justify-center'>
                    <div className='flex justify-center my-4 '>
                        <p className='text-4xl font-bold w-3/4 text-center'>Get a  FREE Online Store with AI</p>
                    </div>
                    <div className='md:text-center my-4'>
                        <p>Create your online store in less than 1min with AI. Simply chat the AI or talk to it and create your professionally design online store for your business</p>
                    </div>
                    <div className='flex justify-center'>
                        <button className='bg-custom-button-green hover:bg-green-600 w-full md:w-1/2  px-4 py-3 rounded' onClick={()=>navigate('/business/onboarding')}>
                            <div className='flex items-center font-semibold'>
                                <div className='flex gap-3'>
                                <img src={storeIcon}/>
                                <p>Create your Store</p>
                                </div>

                                <FaArrowRight className='ml-auto'/>
                            </div>
                        </button>
                    </div>
                </div>

            </div>
        </PrivateLayout>
    )
}

export default OnlineStore
